import { getOrientationLocations, putOrientationLocation, postOrientationLocation, getOrientations, postOrientation,
  getOrientDetails, addOrientAttendees, deleteOrientAttendee } from '../api';
import { dispatchGrassError } from './index';
import * as actionTypes from './actionTypes';

export function getOrientationLocationsList () {
  return dispatch => getOrientationLocations()
    .then(({ data }) => {
      dispatch({ type: actionTypes.GET_ORIENTATION_LOCATIONS_SUCCESS, data });
      return data;
    })
    .catch(error => dispatchGrassError(error, dispatch));
}

export function editOrientationLocation (id, formData) {
  return dispatch => putOrientationLocation(id, formData)
    .then(({ data }) => data)
    .catch(error => dispatchGrassError(error, dispatch));
}

export function createOrientationLocation (formData) {
  return dispatch => postOrientationLocation(formData)
    .then(({ data }) => data)
    .catch(error => dispatchGrassError(error, dispatch));
}

export function getOrientationsList (from_date) {
  return dispatch => getOrientations(from_date)
    .then(({ data }) => {
      dispatch({ type: actionTypes.GET_ORIENTATIONS_SUCCESS, data });
      return data;
    })
    .catch(error => dispatchGrassError(error, dispatch));
}

export function createOrientation (formData) {
  return dispatch => postOrientation(formData)
    .then(({ data }) => data)
    .catch(error => dispatchGrassError(error, dispatch));
}

export function getOrientationDetails (id) {
  return dispatch => getOrientDetails(id)
    .then(({ data }) => {
      dispatch({ type: actionTypes.GET_ORIENTATION_DETAILS_SUCCESS, data });
      return data;
    })
    .catch(error => dispatchGrassError(error, dispatch));
}

export function addOrientationAttendees (orientation_id, user_ids) {
  return dispatch => addOrientAttendees(orientation_id, user_ids)
    .then(({ data }) => data)
    .catch(error => dispatchGrassError(error, dispatch));
}

export function deleteOrientationAttendee (orientation_id, user_id) {
  return dispatch => deleteOrientAttendee(orientation_id, user_id)
    .then(({ data }) => data)
    .catch(error => dispatchGrassError(error, dispatch));
}



// WEBPACK FOOTER //
// ./src/actions/orientations.js